import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

// Local Deps
import './ToolingManagement.scss';
// import uploadToolingHelp from '../../HelpFiles/Tooling Information Upload Example and Instructions.pdf';
import AddTooling from '../../components/AddTooling';
// import ToolingManagementView from '../../components/ToolingManagementView';
import ToolingManagementGrid from '../../components/grids/ToolingManagementGrid'
import UploadTooling from '../../components/UploadTooling/UploadTooling';
import ToolingManagementMenu from '../../components/ToolingManagementMenu';
// import HelpDocButton from '../../components/primitives/HelpDocButton';
import Loading from '../../components/Loading';
import { s3SupportDocs } from '../../config/properties';
import Subscription from '../../components/Subscription/Subscription';

const uploadToolingHelp = `${s3SupportDocs}/ToolingAndInventory/Tooling Information Upload Example and Instructions.pdf`;

function ToolingManagement(props) {
  const {
    isLoading,
    isDownloading,
    auth,
    selectedMenu = {
      text: 'Tooling Management',
      value: 'toolingGrid',
    },
    onMenuClick,
    orgName,
    // userOrgId,
    // changeMetaDataBack,
    onToolFilter,
    toolFilter,
    onReturnToMainPage
  } = props;

  const preposition = selectedMenu.text.includes('Tooling Management') ? 'for' : 'for';

  return (
    <Subscription service="Tooling Management" level="ICON Core">
    <div className="nf-account-admin">
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Tooling Management Page</title>
        <meta name="description" content="description1" />
        <meta name="keywords" content="keyword1,keyword2,keyword3" />
      </Helmet>

      <Row className="nf-account-admin__header">
        {/* <!-- HEADER --> */}
        <Col xs={1} />
        <Col>
          {!orgName && (
            <h1>
              {selectedMenu.text}
              {selectedMenu.value === 'uploadTooling' && (
                <a href={uploadToolingHelp} target="_blank" rel="noopener noreferrer">
                  <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                    PDF Help File
                  </Button>
                </a>
              )}
            </h1>
          )}
          {orgName && (
            <h1>
              {`${selectedMenu.text} ${preposition} ${orgName}`}
              {selectedMenu.value === 'uploadTooling' && (
                <a href={uploadToolingHelp} target="_blank" rel="noopener noreferrer">
                  <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                    PDF Help File
                  </Button>
                </a>
              )}
            </h1>
          )}
        </Col>
        {/* Catharina TODO Remove below button when removing proxy stuff */}
        {/* {userOrgId !== auth.organizationId &&
          isLoading === false && (
            <Col className="button-wrapper">
              <div>
                <Button
                  onClick={() => {
                    changeMetaDataBack(userOrgId);
                  }}
                >
                  go back to your organization?
                </Button>
              </div>
            </Col>
          )} */}
      </Row>
      <Row
        style={{
          flexWrap: 'nowrap',
        }}
      >
        <Col xs={2} className="nf-account-admin__side-panel">
          <ToolingManagementMenu
            onMenuClick={onMenuClick}
            selectedMenu={selectedMenu}
            onToolFilter={onToolFilter}
            isDownloading={isDownloading}
          />
        </Col>
        <Col
          style={{
            padding: 0,
          }}
        >
          {/* <!-- LOADING --> */}
          {isLoading && <Loading text='Loading Tooling Management...' />}

          {/* <!-- CONTENT --> */}
          {!isLoading && (
            <div className="nf-account-admin__content">
              <Row className="nf-row--justify-end" />{' '}
              {/* <!-- Admin Caps Grid --> */}
              <div className="nf-account-admin__grid">
                {selectedMenu.value === 'addTooling' && (
                  <AddTooling
                    auth={auth}
                    onReturnToMainPage={onReturnToMainPage}
                  />
                )}

                {selectedMenu.value === 'toolingGrid' && (
                  <ToolingManagementGrid
                    auth={auth}
                    toolFilter={toolFilter}
                  />
                )}

                {selectedMenu.value === 'uploadTooling' && (
                  <UploadTooling
                    auth={auth}
                    onReturnToMainPage={onReturnToMainPage}
                  />
                )}

                {
                  selectedMenu.value !== 'addTooling' &&
                  selectedMenu.value !== 'uploadTooling' &&
                  selectedMenu.value !== 'downloadTooling' &&
                  selectedMenu.value !== 'toolingGrid' &&
                  <div>TBD</div>}
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div >
    </Subscription>
  );
}

ToolingManagement.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  auth: PropTypes.object.isRequired,
  selectedMenu: PropTypes.object,
  onMenuClick: PropTypes.func.isRequired,
  orgName: PropTypes.string.isRequired,
  // userOrgId: PropTypes.string.isRequired,
  // changeMetaDataBack: PropTypes.func.isRequired,
  onToolFilter: PropTypes.func.isRequired,
  toolFilter: PropTypes.object.isRequired,
  onReturnToMainPage: PropTypes.func.isRequired,
};

ToolingManagement.defaultProps = {
  selectedMenu: {
    text: 'Tooling Management',
    value: 'toolingGrid',
  },
};

export default ToolingManagement;



// WEBPACK FOOTER //
// ./src/pages/ToolingManagement/ToolingManagement.jsx